import { isCancel } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppActions } from "../app";
import { SOMETHING_WENT_WRONG } from "../../../constants/strings";
import { showErrorSnackbar } from "../../../utils/snackbar";

export const createHandledAsyncThunk = (name, asyncFunc) =>
  createAsyncThunk(name, async (payload, options) => {
    try {
      return await asyncFunc(payload, options);
    } catch (e) {
      let errorMessage = e.message;

      if (e.response) {
        errorMessage = e.response.statusText;
        if (e.response.status === 500) {
          errorMessage = SOMETHING_WENT_WRONG;
        }
      }

      !isCancel(e) && showErrorSnackbar(errorMessage || SOMETHING_WENT_WRONG);
      throw e;
    }
  });

export const createLoadingAsyncThunk = (name, asyncFunc) =>
  createHandledAsyncThunk(name, async (payload, options) => {
    try {
      options.dispatch(AppActions.setLoading(true));
      return await asyncFunc(payload, options);
    } finally {
      options.dispatch(AppActions.setLoading(false));
    }
  });
